<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button fill="clear" class="close-button" (click)="dismiss()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <div class="flexed-align-center">
      <ion-button
        fill="clear"
        color="dark"
        style="margin: 0 15px 0 5px"
        (click)="showVersions()"
      >
        <span>
          {{
            selectedFunction?.status === "draft"
              ? "🟠"
              : selectedFunction?.status === "inactive"
                ? "⚪️"
                : "🟢"
          }}
          Version {{ selectedFunction?.version }} ({{
            selectedFunction?.status
          }})
          <ion-icon
            name="chevron-down-outline"
            class="icon-padded-left"
          ></ion-icon
        ></span>
      </ion-button>
      <ion-button
        (click)="save()"
        [disabled]="isLoading"
        [fill]="selectedFunction?.status === 'draft' ? 'clear' : 'outline'"
        color="primary"
        *ngIf="selectedFunction?.status !== 'inactive'"
        class="btn-small"
        style="margin-left: 16px; margin-right: 8px"
      >
        {{
          selectedFunction?.status === "draft"
            ? "Save changes"
            : "Save new version"
        }}
        <ion-spinner
          name="dots"
          [hidden]="!isLoading"
          style="margin-left: 10px"
        ></ion-spinner>
      </ion-button>
      <ion-button
        (click)="promoteDraft()"
        [disabled]="isPublishing"
        *ngIf="selectedFunction?.status === 'draft'"
        class="btn-small"
      >
        Publish
        <ion-spinner
          name="dots"
          [hidden]="!isPublishing"
          style="margin-left: 10px"
        ></ion-spinner>
      </ion-button>
      <ion-button
        style="opacity: 0.6; cursor: default"
        *ngIf="selectedFunction?.status === 'active'"
        class="btn-small"
        ngxTippy
        data-tippy-content="Save changes before publishing"
        [tippyProps]="{
          placement: 'right'
        }"
      >
        Publish
      </ion-button>
      <!-- Hidden because this functionality doesn't work yet -->
      <!-- <ion-button
        (click)="promoteDraft()"
        color="warning"
        [disabled]="isPublishing"
        *ngIf="selectedFunction?.status === 'inactive'"
        class="btn-small"
      >
        Revert to this version
        <ion-spinner name="crescent" [hidden]="!isPublishing" style="margin-left: 10px"></ion-spinner>
      </ion-button> -->
      <ion-button
        color="dark"
        fill="clear"
        [disabled]="true"
        style="margin-left: 10px"
        class="fake-button hidden-sm btn-small"
      >
        {{
          selectedFunction?.updatedAt
            ? "Last published: " + displayDateFrom(selectedFunction.updatedAt)
            : "Not saved yet"
        }}
      </ion-button>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="flexed" style="height: 100%">
    <div class="main-content">
      <ngx-monaco-editor
        #editor
        style="height: 100%"
        class="my-code-editor"
        [options]="editorOptions"
        [(ngModel)]="code"
        (onInit)="onEditorInit($event)"
      ></ngx-monaco-editor>
    </div>
    <div class="right-col hidden-sm">
      <ion-toolbar class="sticky-toolbar">
        <span
          class="tab-nav-link"
          [ngClass]="{ 'tab-nav-active': selectedTab === 'properties' }"
          (click)="selectedTab = 'properties'"
        >
          <ion-icon
            [name]="selectedTab === 'properties' ? 'list' : 'list-outline'"
            style="margin-right: 2px"
          ></ion-icon>
          Properties
        </span>
        <span
          class="tab-nav-link"
          [ngClass]="{ 'tab-nav-active': selectedTab === 'secrets' }"
          (click)="selectedTab = 'secrets'"
        >
          <ion-icon
            [name]="
              selectedTab === 'secrets' ? 'lock-closed' : 'lock-closed-outline'
            "
            style="margin-right: 2px"
          ></ion-icon>
          Secrets
        </span>
        <span
          class="tab-nav-link"
          [ngClass]="{ 'tab-nav-active': selectedTab === 'snippets' }"
          (click)="selectedTab = 'snippets'"
        >
          <ion-icon
            [name]="
              selectedTab === 'snippets'
                ? 'code-working'
                : 'code-working-outline'
            "
            style="margin-right: 2px"
          ></ion-icon>
          Code snippets
        </span>
      </ion-toolbar>
      <div style="padding: 8px">
        <ng-container *ngIf="selectedTab === 'properties'">
          <div
            *ngFor="let variable of inputProperties"
            text-wrap
            style="margin-bottom: 10px"
          >
            <ion-list class="no-padding transparent-bg">
              <ion-item text-wrap>
                <ion-label>
                  <strong> {{ variable.display }}</strong>
                </ion-label>
                <ion-label slot="end">
                  <a
                    slot="end"
                    [href]="variable.docs"
                    target="_blank"
                    *ngIf="variable.model && variable.docs"
                  >
                    <span class="code">{{ variable.model }}</span> Docs
                  </a>
                </ion-label>
              </ion-item>
              <ion-item
                *ngFor="let prop of variable.properties"
                (click)="copyToClipboard(prop.key)"
                button="true"
              >
                <ion-icon name="duplicate-outline" class="copy-icon"></ion-icon>
                {{ prop.display }}
              </ion-item>
            </ion-list>
          </div>
        </ng-container>
        <div *ngIf="selectedTab === 'snippets'">
          <h3 style="margin: 15px">Common Request Types</h3>
          <ion-list class="no-padding transparent-bg">
            <ion-item (click)="copyHTTPRequestStep('POST')" button="true">
              <ion-icon name="duplicate-outline" class="copy-icon"></ion-icon>
              POST Request
            </ion-item>
            <ion-item (click)="copyHTTPRequestStep('PUT')" button="true">
              <ion-icon name="duplicate-outline" class="copy-icon"></ion-icon>
              PUT Request
            </ion-item>
            <ion-item (click)="copyHTTPRequestStep('GET')" button="true">
              <ion-icon name="duplicate-outline" class="copy-icon"></ion-icon>
              GET Request
            </ion-item>
            <ion-item (click)="copyHTTPRequestStep('PATCH')" button="true">
              <ion-icon name="duplicate-outline" class="copy-icon"></ion-icon>
              PATCH Request
            </ion-item>
            <ion-item (click)="copyHTTPRequestStep('DELETE')" button="true">
              <ion-icon name="duplicate-outline" class="copy-icon"></ion-icon>
              DELETE Request
            </ion-item>
            <ion-item
              (click)="copyUnthreadApiCreateMessageStep()"
              button="true"
            >
              <ion-icon name="duplicate-outline" class="copy-icon"></ion-icon>
              Unthread API call to post message
            </ion-item>
          </ion-list>
          <h3 style="margin: 15px">Common Integrations</h3>
          <ion-list class="no-padding transparent-bg">
            <ion-item (click)="copyAddToOktaStep()" button="true">
              <ion-icon name="duplicate-outline" class="copy-icon"></ion-icon>
              Add user to Okta group
            </ion-item>
            <ion-item (click)="copyRemoveFromOktaStep()" button="true">
              <ion-icon name="duplicate-outline" class="copy-icon"></ion-icon>
              Remove user from Okta group
            </ion-item>
          </ion-list>
          <h3 style="margin: 15px">Persistent Store</h3>
          <ion-list class="no-padding transparent-bg">
            <ion-item (click)="copyPersistentStoreCode('set')" button="true">
              <ion-icon name="duplicate-outline" class="copy-icon"></ion-icon>
              Set value
            </ion-item>
            <ion-item (click)="copyPersistentStoreCode('get')" button="true">
              <ion-icon name="duplicate-outline" class="copy-icon"></ion-icon>
              Get value
            </ion-item>
          </ion-list>
        </div>
        <div *ngIf="selectedTab === 'secrets'">
          <ion-list class="no-padding transparent-bg">
            <ion-item
              *ngFor="let secret of secrets"
              (click)="copyToClipboard('secrets[`' + secret.name + '`]')"
              button="true"
            >
              <ion-icon name="duplicate-outline" class="copy-icon"></ion-icon>
              {{ secret.name }}
            </ion-item>
          </ion-list>
        </div>
      </div>
    </div>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-button fill="clear" color="dark" [disabled]="true" class="fake-button">
      Use 'export' to make function available in automations
    </ion-button>
    <ion-button fill="clear" (click)="addFunction()">
      <ion-icon name="add-outline"> </ion-icon>
      Add new function to file
    </ion-button>
    <ion-button fill="clear" (click)="addExternalSelectFunction()">
      <ion-icon name="add-outline"> </ion-icon>
      Add new external select function
    </ion-button>
    <ion-button
      href="https://docs.unthread.io/workflow/automations"
      target="_blank"
      fill="clear"
    >
      <ion-icon name="book-outline" class="padded-icon"></ion-icon>
      Read the docs
    </ion-button>
  </ion-toolbar>
</ion-footer>
